import React, { useEffect } from 'react';

import { Dialog } from '@xingternal/dialog';
import { trackEvent } from '@xingternal/hops-tracking';

import { useDialogCopies } from './use-dialog-copies';

type Props = {
  show: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const DirtyFormCloseDialog: React.VFC<Props> = ({ show, onCancel, onConfirm }) => {
  const dialogCopies = useDialogCopies();

  const onDialogCancel = (): void => {
    onCancel();
    trackEvent('PropTrackAction', { PropTrackAction: 'jobs_apply_exit_cancel' });
  };

  useEffect(() => {
    if (show) {
      trackEvent('PropTrackAction', { PropTrackAction: 'jobs_apply_exit_open' });
    }
  }, [show]);

  return (
    <Dialog
      {...dialogCopies}
      show={show}
      onCancel={onDialogCancel}
      onConfirm={onConfirm}
      data-testid="dirty-form-close-dialog"
    />
  );
};
